import * as React from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { V1TRPCProviders } from "@v1/trpc/V1TRPCProviders";
import { getQueryClient } from "@v2/trpc/trpc";
import { V2TRPCProviders } from "@v2/trpc/V2TRPCProviders";

/**
 * Wraps children with all TRPC-related providers required by the editor.
 */
export function TRPCProviders({ children }: React.PropsWithChildren) {
  return (
    <QueryClientProvider client={getQueryClient()}>
      <V2TRPCProviders>
        <V1TRPCProviders> {children} </V1TRPCProviders>
      </V2TRPCProviders>
    </QueryClientProvider>
  );
}
